import {buildUrlFromConfig} from "./http-request-utils";
import {httpPost} from "./http-functions";

export const transferSubscriptions = async (organizationId: number, from: number, to: number, subscriptions: any) => {
    const path = `transfer-subscriptions/${to}`;
    const url = buildUrlFromConfig({organizationId, organizationUnitId: from, path});
    return await httpPost(
        url,
        {subscriptions}
    );
};

export const resendNotificationForPendingConsent = async (organizationId: number, organizationUnitId: number, userId: string) => {
    const path = `pending-consent-notification/${userId}`;
    const url = buildUrlFromConfig({organizationId, organizationUnitId, path});
    return await httpPost(
        url
    );
};
